import React from "react";
import { LeadCard, ReasonAndTime } from "./parts";
import { toldUs } from "./leadModel.mjs";

/*
 * NEW LEAD, FIRST EMAIL OWED: "What they told us" (frames 1c and 1h, Dana).
 *
 * Their form, named and dated in their zone beside mine ("Get a proposal form ·
 * today 07:05 ET · 14:05 your time"), their message at reading size, the answers
 * under a rule in the frame's order and words, then the score's one-line reason
 * ("Why 80: …") and their time now. The answers come through formAnswers.mjs, which
 * reads all three ways a form has been stored and never reads the warm-intro
 * triage's keys as answers, so an intro lead with no form shows the intro email
 * itself, and a lead with neither says "None, no form" (the Profile tab's words).
 * On the phone the labels are the frame's short ones ("Budget", "Running ads").
 *
 * Props:
 *   record   the shell's bundle: timeline.rows (the form row), contact, company,
 *            zones, score, layout
 *   ops      ops.toggleBreakdown (the reason line's "Breakdown")
 */
export default function NewLead({ record, ops }) {
  const phone = record.layout === "phone";
  const told = toldUs({ rows: record.timeline.rows, company: record.company, contact: record.contact, zones: record.zones, short: phone, now: record.now });
  return (
    <LeadCard label="What they told us" meta={told.meta}>
      {told.kind === "none" ? (
        <div className="rec-empty">{told.empty}</div>
      ) : (
        <>
          {told.message && <div className="rec-quote">{told.message}</div>}
          {told.answers.length > 0 && (
            <div className={`rec-kv ${phone ? "rec-lead__answers--phone" : "rec-kv--150"} rec-sep`}>
              {told.answers.map((a) => (
                <React.Fragment key={a.key}>
                  <span>{a.label}</span>
                  <span>{a.value}</span>
                </React.Fragment>
              ))}
            </div>
          )}
        </>
      )}
      <ReasonAndTime record={record} ops={ops} mode="why" />
    </LeadCard>
  );
}
